/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChicken = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.614 15.771a9.057 9.057 0 0 1-.578.617l-.004.004a36.463 36.463 0 0 1-1.101 1.058 3.437 3.437 0 1 1-6.522 2.172A3.437 3.437 0 1 1 6.58 13.1a46.17 46.17 0 0 1 1.06-1.102l.002-.002c.303-.304.443-.432.591-.557l.007-.006A7.59 7.59 0 0 1 8 9.5C8 5.634 10.634 2 14.5 2S22 4.634 22 8.5c0 4.5-2.784 7.5-7.5 7.5-.668 0-1.3-.079-1.886-.229zM9.12 13.38l-.482.482c-.083.086-.168.17-.253.255-.114.113-.229.227-.338.345a2 2 0 0 1-2.13.525 1.436 1.436 0 0 0-1.496 2.371c.171.172.372.29.585.356a2 2 0 0 1 1.312 1.311 1.437 1.437 0 1 0 2.726-.911 2 2 0 0 1 .525-2.13c.205-.19.41-.383.612-.578l.568-.44A5.747 5.747 0 0 1 9.12 13.38zM20 8.5C20 6.09 17.65 4 14.5 4 12.09 4 10 6.35 10 9.5c0 1.468.491 2.562 1.214 3.285S13.032 14 14.5 14c1.924 0 3.247-.602 4.09-1.462.849-.867 1.41-2.201 1.41-4.038z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChicken as Chicken };
